<template>
  <!-- Chart or table: every chart has a table twin, the same numbers as rows. -->
  <div class="vt" role="group" :aria-label="label">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="vt__option"
      :class="{ 'is-active': modelValue === option.value }"
      :aria-pressed="modelValue === option.value ? 'true' : 'false'"
      :title="option.title"
      @click="$emit('update:modelValue', option.value)"
    >
      <i class="pi" :class="option.icon" aria-hidden="true"></i>
      <span class="sr-only">{{ option.title }}</span>
    </button>
  </div>
</template>
<script>
export default {
  name: 'ViewToggle',
  props: {
    // 'chart' or 'table'.
    modelValue: { type: String, default: 'chart' },
    // The chart's own glyph: a line, bars…
    chartIcon: { type: String, default: 'pi-chart-bar' },
    label: { type: String, default: 'Show as' },
  },
  emits: ['update:modelValue'],
  computed: {
    options() {
      return [
        { value: 'chart', icon: this.chartIcon, title: 'Show as a chart' },
        { value: 'table', icon: 'pi-table', title: 'Show as a table' },
      ];
    },
  },
};
</script>
<style scoped>
.vt {
  display: inline-flex;
  flex: none;
  padding: 2px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-muted);
}

.vt__option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background-color .15s ease, color .15s ease, box-shadow .15s ease;
}

.vt__option .pi {
  font-size: 0.78rem;
}

.vt__option:hover {
  color: var(--color-text-primary);
}

.vt__option.is-active {
  background: var(--color-bg-canvas);
  color: var(--color-primary-hover);
  box-shadow: var(--shadow-xs);
}

.vt__option:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus) !important;
}
</style>
